import React from 'react';
import PropTypes from 'prop-types';
import {withI18n} from 'spa/Components/Context';

import ArrowLeft from '@urbanmassage/component-library/lib/Icons/ArrowLeft/ArrowLeft';
import Button, { ButtonSizeTypes, ButtonThemeTypes, ButtonType } from '@urbanmassage/component-library/lib/Button/Button';
import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';

const GiftsNavigation = ({currentStep, goBack}, {i18n}) => {
  const handleClick = () => {
    goBack(currentStep - 1);
  };

  return (
    <div className="gifts__navigation">
      <div className="gifts__navigation-inner">
        {currentStep === 1 && (
          <React.Fragment>
            <Typography
              variant={TypeVariants.h5}
              data-testid="gifts-navigation-step-one-text"
              className="gifts__navigation-redeem-title"
            >
              {i18n._x('Already have a gift card?', 'Gifts page')}
            </Typography>
            <Button
              href={`/${i18n.lc}/redeem-gift`}
              size={ButtonSizeTypes.small}
              data-testid="gifts-navigation-redeem"
            >
              {i18n._x('Redeem', 'Gifts page')}
            </Button>
          </React.Fragment>
        )}
        {currentStep === 2 && (
          <Button
            preIcon={<ArrowLeft />}
            size={ButtonSizeTypes.small}
            theme={ButtonThemeTypes.transparent}
            type={ButtonType.button}
            onClick={handleClick}
            data-testid="gifts-navigation-back"
          >
            {i18n._x('Back to select & personalise', 'Gifts page')}
          </Button>
        )}
        {currentStep === 3 && (
          <Button
            preIcon={<ArrowLeft />}
            size={ButtonSizeTypes.small}
            theme={ButtonThemeTypes.transparent}
            type={ButtonType.button}
            onClick={handleClick}
            data-testid="gifts-navigation-back"
          >
            {i18n._x('Back to delivery details', 'Gifts page')}
          </Button>
        )}
        {currentStep === 4 && (
          <React.Fragment>
            <Typography
              variant={TypeVariants.h5}
              data-testid="gifts-navigation-step-four-text"
              className="gifts__navigation-redeem-title"
            >
              {i18n._x('Don\'t have a gift card?', 'Gifts page')}
            </Typography>
            <Button
              href={`/${i18n.lc}/buy-gift-card`}
              size={ButtonSizeTypes.small}
              data-testid="gifts-navigation-buy"
            >
              {i18n._x('Buy', 'Gifts page')}
            </Button>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

GiftsNavigation.propTypes = {
  currentStep: PropTypes.number.isRequired,
  goBack: PropTypes.func.isRequired,
};

export default withI18n(GiftsNavigation);



// WEBPACK FOOTER //
// ./spa/Pages/Gifts/GiftsNavigation.jsx